// extracted by mini-css-extract-plugin
module.exports = {"page":"style__page__BCQiJ","body":"style__body__RiDyJ","field":"style__field__DSzqq","assistant":"style__assistant__eXgzl"};